import { Link } from "react-router-dom"

import { Button } from "@/components/ui/button"

export function TerminalScreen({ title, description }: { title: string; description: string }) {
  return (
    <main
      id="main"
      className="mx-auto flex min-h-dvh w-full max-w-md flex-col bg-background text-foreground"
    >
      <header className="border-b-2 border-border px-5 py-5">
        <p className="font-mono text-[10px] uppercase tracking-[0.35em] text-muted-foreground">
          Session · Closed
        </p>
        <h1 className="mt-2 font-mono text-2xl font-bold uppercase tracking-tight text-foreground">
          {title}
        </h1>
      </header>
      <section className="flex-1 px-5 py-6">
        <div
          className="border-2 border-border bg-card p-5"
          style={{ boxShadow: "var(--shadow-brutal)" }}
        >
          <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-muted-foreground">
            Notice
          </p>
          <p className="mt-2 text-base text-foreground">{description}</p>
        </div>
      </section>
      <div className="mt-auto px-5 py-5">
        <Button
          asChild
          className="h-14 w-full bg-primary text-primary-foreground hover:bg-primary"
        >
          <Link to="/">Return home ↗</Link>
        </Button>
      </div>
    </main>
  )
}
